import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { WorkOrderInBoundGrid } from '../../../interfaces/WorkOrder/WorkOrder'
import { AsnAdjustSkuUpdate } from '../../../interfaces/Inbound/InboundAdjust'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { utcFinalDate, utcIntialDate } from '../../../utils/dateHelper'
import { AsnBlogCreate } from '../../../interfaces/Asn/AsnBlog'

export const GetInboundAdjust = (
  pageIndex = 0,
  pageSize = 5,
  orderBy: GenericOrderBy<WorkOrderInBoundGrid>,
  ProductOriginId?: number,
  filters?: Filter[]
) => {
  const url = new URL(ApiConfig.InboundAdjust)

  url.searchParams.set('pageIndex', pageIndex.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  if (ProductOriginId) {
    url.searchParams.set('ProductOriginId', ProductOriginId.toString())
  }

  if (filters) {
    filters.forEach((element) => {
      if (element.key === 'receivedDate' || element.key === 'receivedDate') {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (
        element.key === 'finalCreatedDate' ||
        element.key === 'finalDeliveryDate'
      ) {
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else if (element.key === 'workOrderTag') {
        if (element.value.toString() === '')
          url.searchParams.set('IncludeWithoutTag', 'true')
        else url.searchParams.set(element.key, element.value.toString())
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.get(url.toString())
}

export const getInboundAjustWorkOrder = (
  workOrderId: number,
  pageIndex = 0,
  pageSize = 5,
  lpn?: string
) => {
  const url = new URL(
    `${ApiConfig.InboundAdjustWorkOrder}?workOrderId=${workOrderId}`
  )
  url.searchParams.set('pageIndex', pageIndex.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (lpn) {
    url.searchParams.set('lpn', lpn)
  }

  return axios.get(url.toString())
}

export const getInboundAdjustSku = (
  workOrderId: number,
  page = 0,
  pageSize = 5,
  filters?: Filter[],
  declareExcess?: boolean
) => {
  const url = new URL(`${ApiConfig.InboundAdjustSku}`)

  url.searchParams.set('workOrderId', workOrderId.toString())
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (declareExcess === true)
    url.searchParams.set('declareExcess', declareExcess.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  return axios.get(url.toString())
}

export const putInboundAdjustSku = (dto: AsnAdjustSkuUpdate[]) => {
  const url = new URL(`${ApiConfig.InboundAdjustSku}`)
  return axios.put(url.toString(), dto)
}

export const postDeclareExcess = (dto: AsnAdjustSkuUpdate[]) => {
  const url = new URL(`${ApiConfig.DeclareExcess}`)
  return axios.post(url.toString(), dto)
}

export const getInboundAjustWorkOrderLpn = (
  workOrderId: number,
  pageIndex = 0,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.InboundAdjustWorkOrderLpn}?workOrderId=${workOrderId}`
  )
  url.searchParams.set('pageIndex', pageIndex.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

export const putFinishASN = (
  workOrderId: number,
  userId: number,
  asnBlogCreateDto: AsnBlogCreate
) => {
  const url = new URL(
    `${ApiConfig.InboundApi}/FinishASN/${workOrderId}/${userId}`
  )

  return axios.put(url.toString(), asnBlogCreateDto)
}
